import { connect } from 'react-redux';
import isEmpty from 'ramda/es/isEmpty';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';

import { getIsParent } from 'app/selectors/user';
import getRegAvailable from 'app/selectors/getRegAvailable';


export default compose(
  connect(
    (state, props) => ({
      isParent: getIsParent(state, props),
      hasStudents: !isEmpty(state.students.data),
      regAvailable: getRegAvailable(state),
    })
  ),

  withState('enableChildAdd', 'setEnableChildAdd', false),

  lifecycle({
    componentDidMount() {
      const { setEnableChildAdd, isParent, regAvailable } = this.props;
      setEnableChildAdd(isParent && regAvailable);
    },
    componentDidUpdate(prevProps) {
      const { setEnableChildAdd, isParent, regAvailable } = this.props;
      if (isParent !== prevProps.isParent) {
        setEnableChildAdd(isParent && regAvailable);
      }
    },
  })
);
